import { AlphabetizedItems } from "./alphabetized-items";
import diacritics from 'diacritics';

export class AlphabetizedCollection<T> {
    public items: AlphabetizedItems<T>[] = [];
    public _getLetterMethod: (item: T) => string;
    public sortMethod: (a: T, b: T) => number;

    constructor(unsortedItems: T[], getLetterMethod: (item: T) => string, sortMethod?: (a: T, b: T) => number) {
        this._getLetterMethod = getLetterMethod;
        this.sortMethod = sortMethod;

        for (let item of unsortedItems) {
            this.push(item);
        }
    }

    public getLetterMethod(item: T): string {
        let letter = this._getLetterMethod(item).toUpperCase();
        letter = diacritics.remove(letter);

        if (Number.isInteger(parseInt(letter))) letter = '#';
        else {
            let chrCode = letter.charCodeAt(0);
            if (chrCode < 65 || chrCode > 90) letter = '@';
        }

        return letter;
    }

    public push(item: T) {
        let letter = this.getLetterMethod(item);
        let alphabetizedItem = this.getOrCreateLetter(letter);

        let items = alphabetizedItem.items;
        items.push(item);
        alphabetizedItem.items = this.sortItems(items);
    }

    public hasLetter(letter: string) {
        letter = letter.toUpperCase();

        for (let alphabetizedItem of this.items) {
            if (alphabetizedItem.letter == letter) return true;
        }

        return false;
    }

    public getLetter(letter: string) {
        letter = letter.toUpperCase();

        for (let alphabetizedItem of this.items) {
            if (alphabetizedItem.letter == letter) return alphabetizedItem;
        }

        return null;
    }

    public getOrCreateLetter(letter: string): AlphabetizedItems<T> {
        let alphabetizedItem = this.getLetter(letter);

        if (!alphabetizedItem) {
            alphabetizedItem = new AlphabetizedItems<T>(letter);
            this.items.push(alphabetizedItem);
            this.sortLetters();
        }

        return alphabetizedItem;
    }

    protected sortLetters() {
        this.items = this.items.sort((a, b) => {
            const letter_a = AlphabetizedCollection.removeSpecialCharsAndLowercase(a.letter);
            const letter_b = AlphabetizedCollection.removeSpecialCharsAndLowercase(b.letter);

            if (letter_a < letter_b) return -1;
            if (letter_a > letter_b) return 1;
            return 0;
        });
    }

    protected sortItems(items: T[]) {
        return this.sortMethod ? items.sort(this.sortMethod) : items;
    }

    public static removeSpecialCharsAndLowercase(phrase: string = ''): string {
        if (phrase == null) return '';

        phrase = diacritics.remove(phrase).toLowerCase();

        const match = phrase.match(/([a-z0-9]+)/gm);

        return match !== null && match.length > 0 ? match.join('') : '';
    }
}



// WEBPACK FOOTER //
// ./src/models/alphabetized-collection.ts